'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Healthcare patient experience operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Patient trust pulse',
  kpis: [
    { val: '1,120', lbl: 'Live mentions', live: true },
    { val: '74', lbl: 'Open escalations' },
    { val: '3.6m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 39, tone: 'positive' },
    { lbl: 'Neutral', pct: 34, tone: 'neutral' },
    { lbl: 'Negative', pct: 27, tone: 'negative' },
  ],
  sla: { pct: 79, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'S', text: 'Appointment delayed 2 hours', handle: '@suresh_n', tag: 'Wait time', tagLevel: 'med' },
    { letter: 'P', text: 'Overcharged on discharge bill', handle: '@priya_k', tag: 'Billing', tagLevel: 'high' },
    { letter: 'A', text: 'Rude front-desk staff', handle: '@asha_d', tag: 'Service', tagLevel: 'med' },
    { letter: 'R', text: 'Test report delayed, no update', handle: '@rahul_v', tag: 'Reports', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Trust risk', sub: 'One facility trending negative' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Billing case → admin in 2s' },
  ],
};

export default function HealthcareHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Healthcare'),
      }}
      title={
        <>
          {t('industries_healthcare.patient_trust_is_the_product_the')}{' '}
          <span className="serif-accent italic">{t('industries_healthcare.healthcare_patient_experience_platf')}</span>
          {' '}{t('industries_healthcare.built_for')}{' '}
          <span className="serif-accent italic">{t('industries_healthcare.hospitals_diagnostics_pharma')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_healthcare.when_a_patients_experience_falls_sh')}{' '}
          <span style={BLUE}>{t('industries_healthcare.billing_complaint_on_google_reviews')}</span>{t('industries_healthcare.a_medical_misinformation_wave_on_tw')}{' '}
          <span style={DEEP}>{t('industries_retail_ecommerce.locobuzz_intercepts_all_three')}</span>
        </>
      }
      actions={<BookDemoButton label="Book a Personalised Healthcare CX Demo" />}
      visual={<IndustryCommandCentre ariaLabel="Healthcare patient experience command centre" {...CC} />}
    />
  );
}
